// Single source of truth for anything that needs the production origin:
// canonical URLs, Open Graph tags, JSON-LD and the sitemap generator.
// Change SITE_URL here and everything follows.

export const SITE_URL = 'https://www.mlmind.io'
export const SITE_NAME = 'MLMind'

export const CONTACT = {
  email: 'mlmindbusiness@gmail.com',
  phone: '+995599239551',
  phoneDisplay: '+995 599 239 551',
  city: 'Tbilisi',
  country: 'GE',
  countryName: 'Georgia',
}

/**
 * Where MLMind can be found off-site.
 *
 * Fill in a `url` and the profile appears in the footer and is declared to
 * search engines as `sameAs` on the Organization — which is how Google ties
 * the directory listings, the reviews and the site together as one business.
 * Entries without a url are simply skipped, so nothing on the page ever
 * promises a profile that does not exist yet.
 *
 * Priority for a small studio: Clutch first (buyers shortlist there and it
 * carries verified reviews), then LinkedIn, then the rest.
 */
export const PROFILES = [
  { name: 'Clutch', url: 'https://clutch.co/profile/mlmind' },
  { name: 'LinkedIn', url: '' },
  { name: 'Facebook', url: 'https://www.facebook.com/profile.php?id=61570609156509' },
  { name: 'GoodFirms', url: '' },
  { name: 'Upwork', url: '' },
  { name: 'GitHub', url: '' },
]

export const SOCIAL = PROFILES.filter((profile) => profile.url).map((profile) => profile.url)

// Absolute URL for a site-relative path — search engines and social scrapers
// need the full origin, never a relative path.
export const absoluteUrl = (path = '/') => {
  const clean = String(path || '/')
  return `${SITE_URL}${clean.startsWith('/') ? clean : `/${clean}`}`
}
